site.meetingBoxes = {
	init:function() {
		$('.boxTitle h2', '#meetingBoxes').wrapInner('<a href="#" />');
		$('.boxTitle a', '#meetingBoxes').on('click', function(e) {
			e.preventDefault();
			e.stopPropagation();

			var $this = $(this),
				$box = $this.closest('.box'),
				open = $box.hasClass('open');

			$('.box', '#meetingBoxes').removeClass('open');

			if (!open) {
				$box.toggleClass('open');
			}

			$('body').addClass('onemeeting-open');
		});

		$('ul', '#meetingBoxes').on('click', function(e) {
			e.stopPropagation();
		});

		$('body').on('click', function () {
			var $body = $(this);
			if ($body.is('.onemeeting-open')) {
				$body.removeClass('onemeeting-open');
				$('.box', '#meetingBoxes').removeClass('open');
			}
		});
	}
};

site.inits.push('site.meetingBoxes.init()');
